import createAssignToUserSelectionDropdown from "app/pages/sales-intelligence/sub-modules/assign-to-users/models/selection-dropdown/factory";
import { LEADS_ASSIGN_SELECTION_TOP_N_VALUES } from "app/pages/sales-intelligence/sub-modules/company-search/constants/websites-table";
import type SelectionDropdownFactory from "app/pages/sales-intelligence/sub-modules/table-actions-panel/models/selection-dropdown/SelectionDropdownFactory";

const assignToUserSelectionDropdownFactory: SelectionDropdownFactory = createAssignToUserSelectionDropdown({
    topNValues: LEADS_ASSIGN_SELECTION_TOP_N_VALUES,
});

export default assignToUserSelectionDropdownFactory;
